import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <Section className="bg-cream-50" data-id="element-63" data-mp="pm2eu58fzvl9">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-gold-deep" data-id="element-64" data-mp="avl8c7gyafhi">Incluidos hoy sin costo extra</p>
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-ink-950 sm:text-4xl" data-id="element-65" data-mp="fsv92j9sidkn">
        Cinco bonos estratégicos
      </h2>
      <p className="mt-4 text-base text-ink-800/75 sm:text-lg" data-id="element-66" data-mp="5w0c44t60l8h">
        Cinco materiales adicionales que se suman al libro principal, hoy completamente gratis.
      </p>
      <div className="mt-10 grid gap-3 md:grid-cols-2" data-id="element-67" data-mp="3o3fzy4wprbn0">
        {bonuses.map(bonus => <article key={bonus.number} className="flex h-full flex-col overflow-hidden rounded-3xl border border-ink-950/10 bg-white" data-id="element-68" data-mp="3t181lqn5uc4e">
            <img src={bonus.cover} alt={bonus.coverAlt} className="aspect-[4/3] w-full object-cover" data-id="element-69" data-mp="1r9l9flrj8b6c" />
            <div className="flex flex-1 flex-col p-6" data-id="element-70" data-mp="3ideke10bxu2r">
              <div className="flex items-center justify-between gap-3" data-id="element-71" data-mp="3ic3i65mj8udr">
                <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-ink-950/45" data-id="element-72" data-mp="3df3a5p64hhk0">{bonus.number}</span>
                <span className="rounded-full border border-gold/40 bg-gold/15 px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-gold-deep" data-id="element-73" data-mp="3r8kuvdajp0bm">
                  Gratis hoy
                </span>
              </div>
              <h3 className="mt-4 text-lg font-bold leading-snug text-ink-950" data-id="element-74" data-mp="2ugr103f7o7of">{bonus.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-800/75" data-id="element-75" data-mp="38g0hz5b8r5tg">{bonus.description}</p>
            </div>
          </article>)}
      </div>
      <div className="mt-10" data-id="element-76" data-mp="33fm9xn9n3vvf">
        <CTAButton className="items-center" note="Los 5 bonos se suman al libro principal, sin costo extra." data-id="element-77" data-mp="nq1asy20t0rw" />
      </div>
    </Section>;
}